module.exports = __webpack_public_path__ + "img/ClearIcon.f866ec37.svg";